import { render, staticRenderFns } from "./addBindGoods.vue?vue&type=template&id=92dc46ee&scoped=true&"
import script from "./addBindGoods.vue?vue&type=script&lang=js&"
export * from "./addBindGoods.vue?vue&type=script&lang=js&"
import style0 from "./addBindGoods.vue?vue&type=style&index=0&id=92dc46ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dc46ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92dc46ee')) {
      api.createRecord('92dc46ee', component.options)
    } else {
      api.reload('92dc46ee', component.options)
    }
    module.hot.accept("./addBindGoods.vue?vue&type=template&id=92dc46ee&scoped=true&", function () {
      api.rerender('92dc46ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customParameter/addBindGoods.vue"
export default component.exports